import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'app/_services/language.service';

@Component({
  selector: 'fury-audio-conf',
  templateUrl: './audio-conf.component.html',
  styleUrls: ['./audio-conf.component.scss']
})
export class AudioConfComponent implements OnInit {

  constructor(public languageService : LanguageService) { }

  ngOnInit() {
    // This is intentional
  }

}
